export * from './resource.resolver';
